<template>
  <section v-if="order">
    <div class="text-center">
      <div class="mb-3">{{ $t('message.my_reservations.booking') }} #{{ order.order_code }}</div>
      <button class="btn btn-outline-info mb-3 px-3"
              type="button"
              data-toggle="collapse"
              data-target="#collapseBox"
              aria-expanded="false"
              aria-controls="collapseBox">
        {{ $t('message.home.see_detail_button') }}
      </button>
      <br>
      <div class="collapse" id="collapseBox">
        <div class="well">
          <label>{{ $t('message.my_reservations.reservation_detail') }}</label>
          <table class="table text-left">
            <tr v-if="order.subscription_id">
              <td width="25%">
                <span class="text-orange">
                  <i class="fal fa-calendar-alt"></i> {{ $t('message.subscription.title') }}
                </span>
              </td>
              <td>
                {{ $t('message.subscription.title') }} #{{ order.subscription_id }} - {{ order.subscription.subscription_type | multiLangName }}
                <div class="mt-2">
                  {{ $t('message.subscription.next_subscription') }}:
                  <span class="text-info" v-if="order.subscription.subscription_group.cancel === 0">
                    {{ order.subscription.recurring_date | prettyOnlyDate }}
                  </span>
                  <span class="text-danger" v-else>
                    {{ $t('message.button.cancel') }}
                  </span>
                </div>
                <div class="mt-2">
                  <button class="btn btn-secondary btn-block"
                          @click="openSubscriptionOrdersModal">
                    {{ $t('message.subscription.view_all_bookings') }}
                  </button>
                </div>
              </td>
            </tr>
            <tr v-else-if="order.package_id">
              <td width="25%">
                <span class="text-orange">
                  <i class="fal fa-layer-group"></i> {{ $t('message.my_reservations.package') }}
                </span>
              </td>
              <td>
                {{ $t('message.my_reservations.package') }} #{{ order.package_id }} - {{ order.package.package_type | multiLangName }}
                <div class="mt-2">
                  <button class="btn btn-secondary btn-block"
                          @click="openSubscriptionOrdersModal">
                    {{ $t('message.subscription.view_all_bookings') }}
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                 #{{ order.order_code }} - <span v-html="$options.filters.serviceParentName(order.service_id, globalState.services)"></span>
              </td>
            </tr>
            <tr>
              <td width="25%"><label>{{ $t('message.my_reservations.cleaning_date') }}</label></td>
              <td>{{ order.cleaning_date | prettyDate }}</td>
            </tr>
            <tr>
              <td>
                <label v-if="order.service_id === 1">{{ $t('message.my_reservations.duration') }}</label>
                <label v-else>{{ $t('message.my_reservations.service_type') }}</label>
              </td>
              <td>
                <template v-if="order.service_id === 1">
                  {{ order.work_hour }} {{ $tc('message.hour', order.work_hour) }}
                  <span v-if="$options.filters.orderAdditionalHours(order)">
                     {{ order | orderAdditionalHours }}
                  </span>
                </template>
                <template v-else>
                  {{ globalState.services[order.service_id] | multiLangName }}
                </template>
              </td>
            </tr>
            <tr>
              <td valign="top"><label>{{ $t('message.my_reservations.customer_address')
                }}</label></td>
              <td>
                <p>{{ $t(globalState.placeSizes[order.place_size_id]) | multiLangName }}</p>
                <p>{{ order.address }}</p>
              </td>
            </tr>
            <tr>
              <td><label>{{ $t('message.my_reservations.remark') }}</label></td>
              <td>{{ order.remark }}</td>
            </tr>
            <tr>
              <td><label>{{ $t('message.my_reservations.summary_total.total') }}</label></td>
              <td>{{ order.order_summary_total.total | currency }}</td>
            </tr>
          </table>
        </div>
      </div><!-- end collapse -->
    </div>
    <!-- Orders in subscription -->
    <subscription-orders-modal ref="subscriptionOrdersModal"/>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SubscriptionOrdersModal from './components/SubscriptionOrdersModal'

  export default {
    props: ['order'],
    components: {
      SubscriptionOrdersModal
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      })
    },
    methods: {
      openSubscriptionOrdersModal () {
        this.$refs.subscriptionOrdersModal.showSubscriptionOrdersModal(true)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/OrderSummaryDetail.vue